import { EUserStatus } from '@/models/dtos/enums/eUserStatus'
import { UserDto } from '@/models/dtos/userDto'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export class UserMixin extends Vue {
  getUser(users: UserDto[], userId: string) {
    return users.find(u => u.id === userId)
  }

  getUserInitials(user: UserDto) {
    return `${user.firstName.substr(0, 1)}${user.lastName.substr(0, 1)}`
  }

  userStatusName(status: EUserStatus) {
    let statusName = ''

    switch (status) {
      case EUserStatus.Active:
        statusName = 'Aktywny'
        break
      case EUserStatus.Inactive:
        statusName = 'Niekatywny'
        break
      case EUserStatus.Dismissed:
        statusName = 'Zwolniony'
        break
      default:
        statusName = 'Aktywny'
    }

    return statusName
  }
}
